import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Modal from "react-bootstrap/Modal";
import FinalGuestLogin from "./final-guest-login";
import styles from "./final-guest-login.module.scss";
const FinalGuestLoginModal = (props) => {
    return (_jsx(_Fragment, { children: _jsxs(Modal, Object.assign({ show: props.show, onHide: props.onHide, centered: true, className: styles.paModalWrapper }, { children: [_jsx(Modal.Header, { className: `border-0 ${styles.paModalHeader}`, closeButton: true }), _jsx(Modal.Body, Object.assign({ className: ` ${styles.paModalBody} pt-0` }, { children: _jsx(FinalGuestLogin, {}) }))] })) }));
};
export default FinalGuestLoginModal;
